// Random numbers for the simulation. The World never calls Math.random directly: hosts pass an rng
// (Math.random in play, a seeded one in tests and replays) so a run can be reproduced exactly.
export type Rng = () => number;

// mulberry32: tiny and fast, good enough for gameplay (never for secrets or codes)
export function mulberry32(seed: number): Rng {
  let a = seed | 0;
  return () => {
    a = (a + 0x6d2b79f5) | 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export const randIn = (rng: Rng, a: number, b: number): number => a + rng() * (b - a);
export const pickFrom = <T>(rng: Rng, arr: readonly T[]): T => arr[(rng() * arr.length) | 0];

// Fisher-Yates, in place
export function shuffle<T>(rng: Rng, arr: T[]): T[] {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = (rng() * (i + 1)) | 0;
    const t = arr[i]; arr[i] = arr[j]; arr[j] = t;
  }
  return arr;
}
